export enum ParedesExternasTipo {
  ALVENARIA_REVESTIMENTO = 'ALVENARIA_REVESTIMENTO',
  ALVENARIA_SEM_REVESTIMENTO = 'ALVENARIA_SEM_REVESTIMENTO',
  MADEIRA_APARELHADA = 'MADEIRA_APARELHADA',
  TAIPA_REVESTIDA = 'TAIPA_REVESTIDA',
  OUTRO = 'OUTRO',
}
